import Nullstack from 'nullstack';
export default function IconBluetoothX({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-bluetooth-x",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 8l10 8l-5 4v-16l1.003 .802m0 6.396l-6.003 4.802"
  }), "   ", Nullstack.element("path", {
    d: "M16 6l4 4"
  }), "   ", Nullstack.element("path", {
    d: "M20 6l-4 4"
  }), " ");
}